const PREVENT_STATUS_UPDATE = [
    "ORDER_CANCELLED",
    "SHIPPED_MEDICINES_PACKED",
    "SHIPPED_IN_TRANSIT",
    "DELIVERED",
    "SHIPPED_ERROR"
]
export { PREVENT_STATUS_UPDATE }
